/**
 * arbi logout
 */

import { Command } from 'commander'
import { deleteCredentials, updateConfig, clearChatSession } from '../config.js'
import { success } from '../output.js'

export function registerLogoutCommand(program: Command): void {
  program
    .command('logout')
    .description('Log out of ARBI')
    .option('--json', 'Emit a single JSON object on success (scripting)')
    .action((opts: { json?: boolean }) => {
      deleteCredentials()
      clearChatSession()
      updateConfig({ selectedWorkspaceId: undefined })
      if (opts.json) {
        console.log(JSON.stringify({ ok: true }))
      } else {
        success('Logged out.')
      }
    })
}
